module.exports = __webpack_public_path__ + "img/young-car-driver.37d428c3.png";